module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/fcp-home/',
  octopusPackageId: 'fleet-client-portal-home',
  octopusProjectName: 'Fleet Client Portal Home',
  mountDOMId: '__app__',
  standalone: false,
  frameless: true
};